import { Identifiable, ProjectResource, Resource, Task } from "@planzone/dto";
import { Filter } from "@planzone/dto";

function isFilteredByGroups(
  { allocations }: Identifiable<Task>,
  { groups }: Filter,
): boolean {
  return (
    !!groups &&
    groups.length > 0 &&
    !groups
      .reduce<
        (Identifiable<Resource> | Identifiable<ProjectResource>)[]
      >((acc, { resources }) => [...acc, ...resources], [])
      .find((resource) =>
        allocations.find(
          (allocation) =>
            ("resource" in resource
              ? resource.resource.uuid
              : resource.uuid) === allocation.resource.uuid,
        ),
      )
  );
}

export { isFilteredByGroups };
